import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'

import { StyledAlert } from '../../theme/components/StyledAlert'

export const LoginFailure = ({ error }: { error: any }) => {
  return (
    <Container maxWidth="sm" sx={{ pt: '50px' }}>
      <Card sx={{ p: '20px' }}>
        <CardContent>
          <Typography variant="h2" sx={{ ml: '10px' }}>
            Er is iets misgegaan
          </Typography>
          <Typography
            sx={{
              p: '10px',
              marginBottom: '16px',
            }}
          >
            Er is een fout opgetreden bij het inloggen. Neem contact op met de
            servicedesk.
          </Typography>
          <StyledAlert severity="error">{error.error_description}</StyledAlert>
        </CardContent>
      </Card>
    </Container>
  )
}
